import React, { useState, Fragment } from 'react';
import Tooltip from '@hpstellar/core/Tooltip';

import Icon from '../../ui/components/icon';
import { Grid, Column } from '../../ui/components/grid';

import withWindowResize from '../../ui/components/window-resize';

import './compare-table.less';

const renderOptions = value => {
    if (value && typeof value[0] === 'string') {
        return value;
    }

    return value.reverse().map((specitem, spi) => (
        <Fragment key={`specTitle_${spi}`}>
            <div className="configTitle">{specitem?.title}</div>
            {specitem?.name.map((item, spci) => (
                <div key={`specItem_${spci}`} className="configValue">
                    {item}
                </div>
            ))}
        </Fragment>
    ));
};

const CompareTable = props => {
    const { compareResults, compareProducts, onTooltipOpen, width } = props;
    if (!compareResults) return <div>Loading...</div>;
    if (compareProducts.length <= 1) return null;

    const [collapse, setCollapse] = useState(Array.from({ length: compareResults.length + 1 }, () => true));

    const lastCollapse = compareProducts.length + 1;
    let specCount = 0;

    const toggleCollapse = index => {
        const newCollapse = [...collapse];
        newCollapse[index] = !newCollapse[index];
        setCollapse(newCollapse);
    };

    const emptyItems = Array.from(Array(4 - compareProducts.length).keys());

    //TODO: figure out offers coming from ETR API products
    const offers = compareProducts[0]?.offers
        ? compareProducts.map(p => p.offers.reduce((acc, o) => [...acc, o.value], []).join('<br>'))
        : [];

    return (
        <Grid className="product-table">
            {/* <Column className="title" desktop={12}>
                <button type="button">
                    <span>TITLE NAME</span>
                    <Icon name="minus_m" />
                </button>
                <div className="subtitle">Section description.</div>
            </Column> */}
            {[...compareResults]
                .sort((a, b) => a.order - b.order)
                .map((spec, i) => {
                    specCount += 1;
                    return (
                        <React.Fragment key={i}>
                            <Column
                                key={i}
                                className="category"
                                columnClass={`col-title${i % 2 === 0 ? '' : ' odd'}`}
                                desktop={2}
                                small={4}
                                style={{ zIndex: 498 - specCount }}
                            >
                                {spec.tooltip && (
                                    <Tooltip
                                        className="tooltip"
                                        title={spec.name}
                                        description={spec.tooltip}
                                        position={width >= 1024 ? 'right' : 'left'}
                                        onTooltipOpen={() => onTooltipOpen(true)}
                                        onTooltipClose={() => onTooltipOpen(false)}
                                    />
                                )}
                                {/* {!spec.tooltip && <span className="spacer" />} */}
                                <div className="attrib">{spec.name || spec.title}</div>
                            </Column>
                            <div className="desktop-10 subgrid">
                                {[...spec.specs]
                                    .slice(0, 4)
                                    .reverse()
                                    .map(({ value }, si) => (
                                        <Column
                                            key={`column_${si}`}
                                            className="value"
                                            columnClass={`col-val${i % 2 === 0 ? '' : ' odd'}`}
                                            desktop={2}
                                            small={2}
                                        >
                                            {renderOptions(value)}
                                        </Column>
                                    ))}
                                {emptyItems.map(k => (
                                    <Column
                                        columnClass={`col-val${i % 2 === 0 ? '' : ' odd'}`}
                                        key={k}
                                        desktop={2}
                                        small={2}
                                    />
                                ))}
                                <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                            </div>
                        </React.Fragment>
                    );
                })}
            {offers.length > 0 && (
                <>
                    <Column className="title" desktop={12}>
                        <button type="button" onClick={() => toggleCollapse(lastCollapse)}>
                            <span>offers</span>
                            <Icon name={collapse[lastCollapse] ? 'minus_m' : 'plus_m'} />
                        </button>
                        <div className="subtitle" />
                    </Column>
                    <Column
                        className="category"
                        columnClass={`col-title ${collapse[lastCollapse] ? 'show' : 'hide'}`}
                        desktop={2}
                        small={4}
                    >
                        {/* TODO: add tooltip and style once they provide description data */}
                        {/* <Icon name="tooltip" className="attrib-tootlip" size={30} /> */}
                        <span className="spacer" />
                        <div className="attrib">Current applicable offers</div>
                    </Column>
                    <div className={`desktop-10 subgrid ${collapse[lastCollapse] ? 'show' : 'hide'}`}>
                        {offers.map((offer, i) => (
                            <Column key={i} className="value" columnClass="col-val" desktop={2} small={2}>
                                <span dangerouslySetInnerHTML={{ __html: offer }} />
                            </Column>
                        ))}
                        {emptyItems.map(k => (
                            <Column key={k} desktop={2} small={2} />
                        ))}
                        <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                    </div>
                </>
            )}
        </Grid>
    );
};

export default withWindowResize(CompareTable);
